var chunkMapping = {
	"564": [
		22564
	],
	"672": [
		94672
	]
};
var idToExternalAndNameMapping = {
	"22564": [
		"default",
		"./module",
		78145
	],
	"94672": [
		"default",
		"./module",
		75174
	]
};
var idToRemoteMap = {
	"22564": [
		{
			"externalType": "script",
			"name": "spclaims_management"
		}
	],
	"94672": [
		{
			"externalType": "script",
			"name": "servicejob_management"
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes.chunkMapping = chunkMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToExternalAndNameMapping = idToExternalAndNameMapping;
__webpack_require__.federation.bundlerRuntimeOptions.remotes.idToRemoteMap = idToRemoteMap;
__webpack_require__.remotesLoadingData.moduleIdToRemoteDataMapping = {
	"22564": {
		"shareScope": "default",
		"name": "./module",
		"externalModuleId": 78145,
		"remoteName": "spclaims_management"
	},
	"94672": {
		"shareScope": "default",
		"name": "./module",
		"externalModuleId": 75174,
		"remoteName": "servicejob_management"
	}
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}